"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var p_defer_1 = __importDefault(require("p-defer"));

function mapAgeCleaner(map) {
  var _this = this;

  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'maxAge';
  var processingKey;
  var processingTimer;
  var processingDeferred;

  var cleanup = function cleanup() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this2 = this;

      var setupTimer, _iterator, _step, entry;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(processingKey !== undefined)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              setupTimer = function setupTimer(item) {
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var delay;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          processingDeferred = p_defer_1.default();
                          delay = item[1][property] - Date.now();

                          if (!(delay <= 0)) {
                            _context.next = 6;
                            break;
                          }

                          // Remove the item immediately if the delay is equal to or below 0
                          map.delete(item[0]);
                          processingDeferred.resolve();
                          return _context.abrupt("return");

                        case 6:
                          // Keep track of the current processed key
                          processingKey = item[0];
                          processingTimer = setTimeout(function () {
                            // Remove the item when the timeout fires
                            map.delete(item[0]);

                            if (processingDeferred) {
                              processingDeferred.resolve();
                            }
                          }, delay); // tslint:disable-next-line:strict-type-predicates

                          if (typeof processingTimer.unref === 'function') {
                            // Don't hold up the process from exiting
                            processingTimer.unref();
                          }

                          return _context.abrupt("return", processingDeferred.promise);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
              };

              _context2.prev = 3;
              _iterator = _createForOfIteratorHelper(map);
              _context2.prev = 5;

              _iterator.s();

            case 7:
              if ((_step = _iterator.n()).done) {
                _context2.next = 13;
                break;
              }

              entry = _step.value;
              _context2.next = 11;
              return setupTimer(entry);

            case 11:
              _context2.next = 7;
              break;

            case 13:
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](5);

              _iterator.e(_context2.t0);

            case 18:
              _context2.prev = 18;

              _iterator.f();

              return _context2.finish(18);

            case 21:
              _context2.next = 25;
              break;

            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](3);

            case 25:
              processingKey = undefined;

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 23], [5, 15, 18, 21]]);
    }));
  };

  var reset = function reset() {
    processingKey = undefined;

    if (processingTimer !== undefined) {
      clearTimeout(processingTimer);
      processingTimer = undefined;
    }

    if (processingDeferred !== undefined) {
      // tslint:disable-line:early-exit
      processingDeferred.reject(undefined);
      processingDeferred = undefined;
    }
  };

  var originalSet = map.set.bind(map);

  map.set = function (key, value) {
    if (map.has(key)) {
      // If the key already exist, remove it so we can add it back at the end of the map.
      map.delete(key);
    } // Call the original `map.set`


    var result = originalSet(key, value); // If we are already processing a key and the key added is the current processed key, stop processing it

    if (processingKey && processingKey === key) {
      reset();
    } // Always run the cleanup method in case it wasn't started yet


    cleanup(); // tslint:disable-line:no-floating-promises

    return result;
  };

  cleanup(); // tslint:disable-line:no-floating-promises

  return map;
}

exports.default = mapAgeCleaner; // Add support for CJS

module.exports = mapAgeCleaner;
module.exports.default = mapAgeCleaner;